import SectionWrapper from '../../pass-templates-new/SectionWrapper';
import FeaturedActionSlots from '../../pass-templates-new/FeaturedActionSlots';
import { FEATURED_ACTION_SLOT_KEYS } from '../../pass-templates-new/utils/featuredActionTypes';
import type {
  AppleEnhancedDesignFeaturedActions,
  FeaturedAction,
  FeaturedActionSlotKey,
} from '../../../../store/types/template';

const ERROR_PREFIX = 'featuredActions';

interface FeaturedActionsSectionProps {
  value: AppleEnhancedDesignFeaturedActions;
  errors?: Record<string, string>;
  onChange: (
    slot: FeaturedActionSlotKey,
    partial: Partial<FeaturedAction>
  ) => void;
  onRemove: (slot: FeaturedActionSlotKey) => void;
  onSwap: () => void;
  setFieldError?: (path: string, message: string | null) => void;
  onFieldFocus?: (identifier: string) => void;
}

const FeaturedActionsSection = ({
  value,
  errors = {},
  onChange,
  onRemove,
  onSwap,
  setFieldError,
  onFieldFocus,
}: FeaturedActionsSectionProps) => {
  const clearSlotErrors = (slot: FeaturedActionSlotKey) => {
    setFieldError?.(`${ERROR_PREFIX}.${slot}.type`, null);
    setFieldError?.(`${ERROR_PREFIX}.${slot}.url`, null);
  };

  return (
    <SectionWrapper
      id="featured-actions-section"
      title="Featured actions"
      tooltip="Tappable buttons shown below the pass in Apple Wallet, each linking out to a URL."
      subtitle="Add up to 2 tappable buttons shown below your pass on iOS 27."
      openOnLoad
    >
      <FeaturedActionSlots
        value={value}
        errors={errors}
        errorPrefix={ERROR_PREFIX}
        onChange={(slot, partial) => {
          onChange(slot, partial);
          clearSlotErrors(slot);
        }}
        onRemove={(slot) => {
          onRemove(slot);
          clearSlotErrors(slot);
        }}
        onSwap={() => {
          onSwap();
          FEATURED_ACTION_SLOT_KEYS.forEach(clearSlotErrors);
        }}
        onFieldFocus={(path) => onFieldFocus?.(`${ERROR_PREFIX}.${path}`)}
      />
    </SectionWrapper>
  );
};

export default FeaturedActionsSection;
